<template>
  <div class="table-header">
    <div class="header-button-lf">
      <slot />
    </div>
    <div class="header-button-ri">
      <el-button icon="el-icon-refresh" circle @click="handleRefresh"></el-button>

      <el-popover v-if="storageKey" placement="bottom-end" width="150" trigger="click">
        <el-button slot="reference" icon="el-icon-s-operation" circle></el-button>

        <el-checkbox v-model="allColumnsSelected" :indeterminate="allColumnsSelectedIndeterminate" @change="CheckAllChange">
          全选
        </el-checkbox>
        <el-checkbox
          v-for="item in tableColumns"
          :key="item.property"
          v-model="item.visible"
          @change="handleCheckedTableColumnsChange(item)"
        >
          {{ item.label }}
        </el-checkbox>
      </el-popover>
    </div>
  </div>
</template>

<script>
function sortWithRef(src, ref) {
  const result = Object.assign([], ref);
  let cursor = -1;
  src.forEach(e => {
    const idx = result.indexOf(e);
    if (idx === -1) {
      cursor += 1;
      result.splice(cursor, 0, e);
    } else {
      cursor = idx;
    }
  });
  return result;
}
export default {
  props: {
    refTable: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 隐藏列表缓存的key，每个列表唯一
    storageKey: {
      type: String,
      default: () => {
        return '';
      }
    }
  },
  data() {
    return {
      allColumnsSelected: true,
      allColumnsSelectedIndeterminate: false,
      ignoreNextTableColumnsChange: false,
      tableColumns: []
    };
  },

  mounted() {
    if (this.storageKey) {
      this.$nextTick(() => {
        this.getTable();
      });
    }
  },
  beforeDestroy() {},
  methods: {
    handleRefresh() {
      //  调用父组件方法
      this.$emit('onRefresh');
    },
    /**
     * 字段单选
     */
    handleCheckedTableColumnsChange(item) {
      let totalCount = 0;
      let selectedCount = 0;
      this.tableColumns.forEach(column => {
        ++totalCount;
        selectedCount += column.visible ? 1 : 0;
      });
      if (selectedCount === 0) {
        openMessage('请至少选择一列', 2);
        this.$nextTick(function () {
          item.visible = true;
        });
        return;
      }
      this.allColumnsSelected = selectedCount === totalCount;
      this.allColumnsSelectedIndeterminate = selectedCount !== totalCount && selectedCount !== 0;
      this.updateColumnVisible(item);
    },

    updateColumnVisible(item) {
      const table = this.$parent.$refs.table ? this.$parent.$refs.table : this.refTable; //子组件获取父组件this.$parent.$refs.名称
      const vm = table.$children.find(e => e.prop === item.property);
      const columnConfig = vm.columnConfig;

      if (item.visible) {
        // 找出合适的插入点
        const columnIndex = this.tableColumns.indexOf(item) + 1;
        vm.owner.store.commit('insertColumn', columnConfig, columnIndex + 1, null);
      } else {
        vm.owner.store.commit('removeColumn', columnConfig, null);
      }
      this.ignoreNextTableColumnsChange = true;

      // 缓存隐藏的列
      if (this.storageKey) {
        const hiddenColumns = this.tableColumns.filter(e => !e.visible).map(item => item.label);
        localStorage.setItem(this.storageKey, JSON.stringify(hiddenColumns));
      }

      this.$nextTick(() => {
        this.refTable.doLayout(); // 重置表格布局
      });
    },
    //字段全选
    CheckAllChange(val) {
      if (val === false) {
        this.allColumnsSelected = true;
        return;
      }
      this.tableColumns.forEach(column => {
        if (!column.visible) {
          column.visible = true;
          this.updateColumnVisible(column);
        }
      });
      this.allColumnsSelected = val;
      this.allColumnsSelectedIndeterminate = false;
    },

    /**
     * 获取表格字段
     */
    getTable() {
      let that = this;
      const table = that.$parent.$refs.table ? that.$parent.$refs.table : this.refTable;

      if (!table) {
        this.tableColumns = [];
        return;
      }
      let cols = null;
      const columnFilter = e => e && e.type === 'default' && e.property && table.columns.indexOf(e.property) === -1;
      const refCols = table.columns.filter(columnFilter);
      if (this.ignoreNextTableColumnsChange) {
        this.ignoreNextTableColumnsChange = false;
        return;
      }
      this.ignoreNextTableColumnsChange = false;
      const columns = [];
      const fullTableColumns = table.$children.map(e => e.columnConfig).filter(columnFilter);
      cols = sortWithRef(fullTableColumns, refCols);

      // 获取隐藏的列
      let hiddenColumns = [];
      if (this.storageKey) hiddenColumns = JSON.parse(localStorage.getItem(this.storageKey)) || [];
      cols.forEach(config => {
        const column = {
          property: config.property,
          label: config.label,
          visible: refCols.indexOf(config) !== -1 && !hiddenColumns.includes(config.label)
        };
        columns.push(column);
      });

      this.tableColumns = columns;

      if (this.tableColumns.some(column => !column.visible)) {
        this.allColumnsSelected = false;
        this.allColumnsSelectedIndeterminate = true;
      }
      this.$nextTick(() => {
        this.tableColumns.forEach(column => {
          if (!column.visible) {
            this.updateColumnVisible(column);
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
